// extracted by mini-css-extract-plugin
export const root = "initiative-list-module--root--2Ka4r";
export const item = "initiative-list-module--item--3T0oR";
export const link = "initiative-list-module--link--8ZQfR";
export const text = "initiative-list-module--text--28YlI";
export const image = "initiative-list-module--image--XfnBX";